// Generated by purs version 0.15.16
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Plus from "../Control.Plus/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Combinators from "../Data.Argonaut.Decode.Combinators/index.js";
import * as Data_Argonaut_Decode_Decoders from "../Data.Argonaut.Decode.Decoders/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tree from "../Data.Tree/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as $$Error from "../Error/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as GraphQL from "../GraphQL/index.js";
import * as GraphQL_Join from "../GraphQL.Join/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Shape from "../GraphQL.Shape/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_Luxon from "../Internal.Luxon/index.js";
import * as Internal_SelectionMap from "../Internal.SelectionMap/index.js";
import * as Translate from "../Translate/index.js";
import * as Widgets_Form_AutoFillSubForm from "../Widgets.Form.AutoFillSubForm/index.js";
import * as Widgets_Form_Checkbox from "../Widgets.Form.Checkbox/index.js";
import * as Widgets_Form_Class from "../Widgets.Form.Class/index.js";
import * as Widgets_Form_Date from "../Widgets.Form.Date/index.js";
import * as Widgets_Form_Dynamic from "../Widgets.Form.Dynamic/index.js";
import * as Widgets_Form_EmployerSelect from "../Widgets.Form.EmployerSelect/index.js";
import * as Widgets_Form_Expectations from "../Widgets.Form.Expectations/index.js";
import * as Widgets_Form_List from "../Widgets.Form.List/index.js";
import * as Widgets_Form_NumberInput from "../Widgets.Form.NumberInput/index.js";
import * as Widgets_Form_PhoneInput from "../Widgets.Form.PhoneInput/index.js";
import * as Widgets_Form_Radio from "../Widgets.Form.Radio/index.js";
import * as Widgets_Form_Select from "../Widgets.Form.Select/index.js";
import * as Widgets_Form_Simple from "../Widgets.Form.Simple/index.js";
import * as Widgets_Form_StudentSubForm from "../Widgets.Form.StudentSubForm/index.js";
import * as Widgets_Form_SubForm from "../Widgets.Form.SubForm/index.js";
import * as Widgets_Form_TextInput from "../Widgets.Form.TextInput/index.js";
import * as Widgets_Signature_Types from "../Widgets.Signature.Types/index.js";
var inputIsSymbol = {
    reflectSymbol: function () {
        return "input";
    }
};
var encRNTY = /* #__PURE__ */ GraphQL_Type.encRNTY(Data_Argonaut_Encode_Class.encodeJsonJString);
var form_type_orderIsSymbol = {
    reflectSymbol: function () {
        return "form_type_order";
    }
};
var buildMutation = /* #__PURE__ */ GraphQL_Query.buildMutation(/* #__PURE__ */ GraphQL_Query.rlTVars(/* #__PURE__ */ GraphQL_Query.rltvCons(GraphQL_Query.rltvNil)(inputIsSymbol)(/* #__PURE__ */ GraphQL_Type.rntyType({
    reflectSymbol: function () {
        return "UserOptionsInput";
    }
}))(/* #__PURE__ */ GraphQL_Type.encRNTY(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(encRNTY))(Data_Argonaut_Encode_Class.gEncodeJsonNil)(form_type_orderIsSymbol)())()))()())(/* #__PURE__ */ GraphQL_Query.rltvfNamedTypeRec(GraphQL_Query.rltvfNil)(inputIsSymbol)()()(/* #__PURE__ */ GraphQL_Query.rltvfConsOther(GraphQL_Query.rltvfNil)(form_type_orderIsSymbol)()))())(GraphQL_Query.unitQR);
var ordRNTY = /* #__PURE__ */ GraphQL_Type.ordRNTY(Data_Ord.ordString);
var selectAll = /* #__PURE__ */ Internal_SelectionMap.selectAll(ordRNTY);
var select = /* #__PURE__ */ Internal_SelectionMap.select(ordRNTY);
var isSelected = /* #__PURE__ */ Internal_SelectionMap.isSelected(ordRNTY);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var getField = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonString);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var elem = /* #__PURE__ */ Data_Array.elem(Data_Eq.eqString);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var decRNTY = /* #__PURE__ */ GraphQL_Type.decRNTY(Data_Argonaut_Decode_Class.decodeJsonString);
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decRNTY));
var gDecodeJsonCons2 = /* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var updateIsSymbol = {
    reflectSymbol: function () {
        return "update";
    }
};
var deleteIsSymbol = {
    reflectSymbol: function () {
        return "delete";
    }
};
var createIsSymbol = {
    reflectSymbol: function () {
        return "create";
    }
};
var decodeRecord = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons2(updateIsSymbol)()())(deleteIsSymbol)()())(createIsSymbol)()())();
var gDecodeJsonCons3 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean));
var useDefaultIsSymbol = {
    reflectSymbol: function () {
        return "useDefault";
    }
};
var saveDefaultIsSymbol = {
    reflectSymbol: function () {
        return "saveDefault";
    }
};
var requestIsSymbol = {
    reflectSymbol: function () {
        return "request";
    }
};
var relationship_labelIsSymbol = {
    reflectSymbol: function () {
        return "relationship_label";
    }
};
var relationshipIsSymbol = {
    reflectSymbol: function () {
        return "relationship";
    }
};
var labelIsSymbol = {
    reflectSymbol: function () {
        return "label";
    }
};
var keyIsSymbol = {
    reflectSymbol: function () {
        return "key";
    }
};
var emailLabelIsSymbol = {
    reflectSymbol: function () {
        return "emailLabel";
    }
};
var canIsSymbol = {
    reflectSymbol: function () {
        return "can";
    }
};
var decodeArray = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(/* #__PURE__ */ gDecodeJsonCons3(Data_Argonaut_Decode_Class.gDecodeJsonNil)(useDefaultIsSymbol)()())(updateIsSymbol)()())(saveDefaultIsSymbol)()())(requestIsSymbol)()())(createIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons2(relationship_labelIsSymbol)()())(relationshipIsSymbol)()())(labelIsSymbol)()())(keyIsSymbol)()())(emailLabelIsSymbol)()())(canIsSymbol)()())());
var typeIsSymbol = {
    reflectSymbol: function () {
        return "type";
    }
};
var signaturesIsSymbol = {
    reflectSymbol: function () {
        return "signatures";
    }
};
var priorityIsSymbol = {
    reflectSymbol: function () {
        return "priority";
    }
};
var mutationsIsSymbol = {
    reflectSymbol: function () {
        return "mutations";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var bgColorIsSymbol = {
    reflectSymbol: function () {
        return "bgColor";
    }
};
var abbrIsSymbol = {
    reflectSymbol: function () {
        return "abbr";
    }
};
var rlhsCons = /* #__PURE__ */ GraphQL_Shape.rlhsCons(GraphQL_Shape.rlhsNil);
var deselect = /* #__PURE__ */ Internal_SelectionMap.deselect(ordRNTY);
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Argonaut_Core.eqJson);
var map = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Either.applicativeEither);
var getField1 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeForeignObject(Data_Argonaut_Decode_Class.decodeJsonJson));
var getFieldOptional$prime = /* #__PURE__ */ Data_Argonaut_Decode_Combinators["getFieldOptional$prime"](Data_Argonaut_Decode_Class.decodeJsonString);
var getFieldOptional$prime1 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators["getFieldOptional$prime"](Data_Argonaut_Decode_Class.decodeJsonBoolean);
var fromFoldable = /* #__PURE__ */ Data_List.fromFoldable(Data_Foldable.foldableArray);
var empty = /* #__PURE__ */ Control_Plus.empty(Data_List_Types.plusList);
var getField2 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonBoolean);
var getField3 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonJson);
var wrapFormWidget = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_List.showLW)(Widgets_Form_List.listFW);
var getId = /* #__PURE__ */ Widgets_Form_Class.getId(Widgets_Form_Dynamic.dynFormWidget);
var wrapFormWidget1 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_SubForm.showSubForm)(Widgets_Form_SubForm.subFormFW);
var wrapFormWidget2 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_StudentSubForm.showStudentSubForm)(Widgets_Form_StudentSubForm.stsfFW);
var wrapFormWidget3 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_AutoFillSubForm.showAFSF)(Widgets_Form_AutoFillSubForm.afsfFW);
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJString);
var decodeJsonMaybe = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJsonMaybe(Data_Argonaut_Decode_Class.decodeJsonString);
var getField4 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(decodeJsonMaybe);
var valueIsSymbol = {
    reflectSymbol: function () {
        return "value";
    }
};
var getField5 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonJson))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(valueIsSymbol)()())(labelIsSymbol)()())()));
var getFieldOptional$prime2 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators["getFieldOptional$prime"](Data_Argonaut_Decode_Class.decodeJsonJson);
var wrapFormWidget4 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_Select.showSelect)(Widgets_Form_Select.selectFW);
var wrapFormWidget5 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_EmployerSelect.showESelect)(Widgets_Form_EmployerSelect.employerSelectFW);
var wrapFormWidget6 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_Date.showDateInput)(Widgets_Form_Date.dateFW);
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Data_Maybe.bindMaybe);
var wrapFormWidget7 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_PhoneInput.showPhoneInput)(Widgets_Form_PhoneInput.phoneInputFW);
var getField6 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons2(valueIsSymbol)()())(labelIsSymbol)()())()));
var wrapFormWidget8 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_Radio.showRadio)(Widgets_Form_Radio.radioFW);
var wrapFormWidget9 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_Checkbox.showCheckbox)(Widgets_Form_Checkbox.checkboxFW);
var getField7 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonNumber);
var getFieldOptional$prime3 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators["getFieldOptional$prime"](Data_Argonaut_Decode_Class.decodeJsonNumber);
var wrapFormWidget10 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_NumberInput.showNumberInput)(Widgets_Form_NumberInput.numberInputFW);
var wrapFormWidget11 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_Simple.showLabel)(Widgets_Form_Simple.labelFW);
var wrapFormWidget12 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_TextInput.showTextInput)(Widgets_Form_TextInput.textInputFW);
var getFieldOptional$prime4 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators["getFieldOptional$prime"](decodeJsonMaybe);
var wrapFormWidget13 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_TextInput.showTextArea)(Widgets_Form_TextInput.textAreaFW);
var wrapFormWidget14 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_Date.showDateTimeInput)(Widgets_Form_Date.dateTimeFW);
var wrapFormWidget15 = /* #__PURE__ */ Widgets_Form_Dynamic.wrapFormWidget(Widgets_Form_Simple.showFormError)(Widgets_Form_Simple.formErrFW);
var getField8 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(decRNTY);
var getField9 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(Data_Argonaut_Decode_Class.decodeJsonInt);
var getField10 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(decodeRecord);
var getField11 = /* #__PURE__ */ Data_Argonaut_Decode_Combinators.getField(decodeArray);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var gqlQuery = /* #__PURE__ */ GraphQL_Join.gqlQuery(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(encRNTY)(Data_Argonaut_Encode_Class.gEncodeJsonNil)(idIsSymbol)())());
var queryStringParams = /* #__PURE__ */ GraphQL.queryStringParams(Data_Foldable.foldableArray);
var areAllSelected = /* #__PURE__ */ Internal_SelectionMap.areAllSelected(ordRNTY);
var setFormOrder = function (ids) {
    return GraphQL_Query.nameQuery("SetFormOrder")(buildMutation("setUserOption")({
        input: GraphQL_Type.namedType({
            form_type_order: ids
        })
    }));
};
var selectForms = function (dictFunctor) {
    var map1 = Data_Functor.map(dictFunctor);
    return function (dictFoldable) {
        var selectAll1 = selectAll(dictFoldable);
        return function (forms) {
            return function (select1) {
                return function (fpm) {
                    var forms$prime = map1(function (f) {
                        return new Data_Tuple.Tuple(f.id, f);
                    })(forms);
                    return selectAll1(forms$prime)(fpm)(select1);
                };
            };
        };
    };
};
var selectForm = function (form) {
    return function (fpm) {
        return select(form.id)(form)(fpm);
    };
};
var isFormSelected = function (form) {
    return function (fpm) {
        return isSelected(form.id)(fpm);
    };
};
var hiddenWidgets = [ "ID", "Hidden" ];
var notHiddenWidget = function (obj) {
    return Data_Maybe.fromMaybe(true)(Data_Either.hush(bind(bind(Data_Argonaut_Decode_Decoders.decodeJObject(obj))(function (v) {
        return getField(v)("type");
    }))(function (type$prime) {
        return pure(!elem(type$prime)(hiddenWidgets));
    })));
};
var getSelectedForm = /* #__PURE__ */ Internal_SelectionMap.getSelected(ordRNTY);
var formTypeFields = function (fields) {
    return "\x0a    id\x0a    type\x0a    abbr\x0a    bgColor\x0a    label\x0a    priority\x0a    signatures { " + (Widgets_Signature_Types.formSigFieldFields + (" }\x0a    mutations {\x0a        create\x0a        update\x0a        delete\x0a    }\x0a    " + ((function () {
        if (fields) {
            return "fields";
        };
        return "";
    })() + "\x0a")));
};
var formsQuery = /* #__PURE__ */ (function () {
    return "query { form_types" + (formTypeFields(false) + "}");
})();
var formListQuery = /* #__PURE__ */ GraphQL_Query.nameQuery("FormTypeList")(/* #__PURE__ */ GraphQL_Query.buildQuery(/* #__PURE__ */ GraphQL_Query.rlTVars(GraphQL_Query.rltvNil)(GraphQL_Query.rltvfNil)())(/* #__PURE__ */ GraphQL_Query.arrayQR(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeRecord))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(decodeArray))(/* #__PURE__ */ gDecodeJsonCons2(typeIsSymbol)()())(signaturesIsSymbol)()())(priorityIsSymbol)()())(mutationsIsSymbol)()())(labelIsSymbol)()())(idIsSymbol)()())(bgColorIsSymbol)()())(abbrIsSymbol)()())()))(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(typeIsSymbol)(GraphQL_Shape.scalarShape)()())(signaturesIsSymbol)(/* #__PURE__ */ GraphQL_Shape.arrayShape(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(relationship_labelIsSymbol)(GraphQL_Shape.scalarShape)()())(relationshipIsSymbol)(GraphQL_Shape.scalarShape)()())(labelIsSymbol)(GraphQL_Shape.scalarShape)()())(keyIsSymbol)(GraphQL_Shape.scalarShape)()())(emailLabelIsSymbol)(GraphQL_Shape.scalarShape)()())(canIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(useDefaultIsSymbol)(GraphQL_Shape.scalarShape)()())(updateIsSymbol)(GraphQL_Shape.scalarShape)()())(saveDefaultIsSymbol)(GraphQL_Shape.scalarShape)()())(requestIsSymbol)(GraphQL_Shape.scalarShape)()())(createIsSymbol)(GraphQL_Shape.scalarShape)()())())()())()))()())(priorityIsSymbol)(GraphQL_Shape.scalarShape)()())(mutationsIsSymbol)(/* #__PURE__ */ GraphQL_Shape.recShape(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ GraphQL_Shape.rlhsCons(/* #__PURE__ */ rlhsCons(updateIsSymbol)(GraphQL_Shape.scalarShape)()())(deleteIsSymbol)(GraphQL_Shape.scalarShape)()())(createIsSymbol)(GraphQL_Shape.scalarShape)()())())()())(labelIsSymbol)(GraphQL_Shape.scalarShape)()())(idIsSymbol)(GraphQL_Shape.scalarShape)()())(bgColorIsSymbol)(GraphQL_Shape.scalarShape)()())(abbrIsSymbol)(GraphQL_Shape.scalarShape)()())())))("form_types")({}));
var emptyFormPickerMap = Internal_SelectionMap.empty;
var deselectForm = function (form) {
    return function (fpm) {
        return deselect(form.id)(fpm);
    };
};
var decodePhpJObj = function (v) {
    if (eq(v)(Data_Argonaut_Core.fromArray([  ]))) {
        return pure(Foreign_Object.empty);
    };
    return Data_Argonaut_Decode_Decoders.decodeJObject(v);
};
var decodeSections = function (context) {
    return function (json) {
        return bind(Data_Argonaut_Decode_Decoders.getField(decodePhpJObj)(json)("fields"))(function (fields) {
            return map(Data_Array.concat)(traverse(decodeSection(context))(Foreign_Object.toArrayWithKey(Data_Tuple.Tuple.create)(fields)));
        });
    };
};
var decodeSection = function (context) {
    return function (v) {
        var id = (function () {
            if (context instanceof Data_Maybe.Just) {
                return context.value0 + ("." + v.value0);
            };
            if (context instanceof Data_Maybe.Nothing) {
                return v.value0;
            };
            throw new Error("Failed pattern match at API.FormType (line 187, column 10 - line 189, column 23): " + [ context.constructor.name ]);
        })();
        var fromFS = function (v1) {
            return {
                id: id,
                workQueueLabel: v1.workQueueLabel
            };
        };
        var decodeFormSection = bind(bind(Data_Argonaut_Decode_Decoders.decodeJObject(v.value1))(function (v1) {
            return getField1(v1)("value");
        }))(function (value) {
            return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(value)("workQueueLabel"))("No Label"))(function (workQueueLabel) {
                return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime1(value)("section"))(false))(function (section) {
                    return pure({
                        value: value,
                        workQueueLabel: workQueueLabel,
                        section: section
                    });
                });
            });
        });
        var checkValidFormSection = function (fs) {
            return fs.section && fs.workQueueLabel !== "No Label";
        };
        var doDecode = bind(decodeFormSection)(function (fs) {
            return bind(decodeSections(new Data_Maybe.Just(id))(fs.value))(function (subforms) {
                var $433 = checkValidFormSection(fs);
                if ($433) {
                    return pure([ Data_Tree.mkTree(fromFS(fs))(fromFoldable(subforms)) ]);
                };
                return pure(subforms);
            });
        });
        var matchSectionWidgets = function (v1) {
            if (v1 === "Label") {
                return bind(decodeFormSection)(function (fs) {
                    var $435 = checkValidFormSection(fs);
                    if ($435) {
                        return pure([ Data_Tree.mkTree(fromFS(fs))(empty) ]);
                    };
                    return pure([  ]);
                });
            };
            if (Data_String_CodeUnits.contains("SubForm")(v1)) {
                return doDecode;
            };
            if (Data_Boolean.otherwise) {
                return pure([  ]);
            };
            throw new Error("Failed pattern match at API.FormType (line 208, column 5 - line 213, column 25): " + [ v1.constructor.name ]);
        };
        return bind(bind(Data_Argonaut_Decode_Decoders.decodeJObject(v.value1))(function (v1) {
            return getField(v1)("type");
        }))(function (type$prime) {
            return matchSectionWidgets(type$prime);
        });
    };
};
var toFormWidgetState = function (v) {
    return bind($$Error.wrapJsonError(Data_Argonaut_Decode_Decoders.decodeJObject(v.value1)))(function (obj) {
        return bind($$Error.wrapJsonError(getField(obj)("type")))(function (type$prime) {
            return bind($$Error.wrapJsonError(getField2(obj)("list")))(function (list) {
                var maybeLabel = bind(bind(getField3(obj)("value"))(Data_Argonaut_Decode_Decoders.decodeJObject))(function (v1) {
                    return getField(v1)("label");
                });
                var label = (function () {
                    if (maybeLabel instanceof Data_Either.Right) {
                        return maybeLabel.value0;
                    };
                    if (maybeLabel instanceof Data_Either.Left) {
                        return "";
                    };
                    throw new Error("Failed pattern match at API.FormType (line 274, column 21 - line 276, column 29): " + [ maybeLabel.constructor.name ]);
                })();
                return bind(matchWidget(v.value0)(obj)(type$prime))(function (widget) {
                    if (list) {
                        return pure(wrapFormWidget(Widgets_Form_List.simpleListWidget({
                            id: getId(widget),
                            label: label,
                            template: widget,
                            cls: ""
                        })));
                    };
                    return pure(widget);
                });
            });
        });
    });
};
var matchWidget = function (v) {
    return function (v1) {
        return function (v2) {
            if (Data_String_CodeUnits.contains("SubForm")(v2)) {
                return bind($$Error.wrapJsonError(getField1(v1)("value")))(function (v3) {
                    return bind($$Error.wrapJsonError(getField2(v3)("section")))(function (section) {
                        return bind($$Error.wrapJsonError(getField2(v3)("collapsible")))(function (collapsible) {
                            return bind($$Error.wrapJsonError(getField2(v3)("expanded")))(function (expanded) {
                                return bind($$Error.wrapJsonError(getFieldOptional$prime(v3)("label")))(function (label) {
                                    var defaultLabelClass = (function () {
                                        if (section) {
                                            return "label-section";
                                        };
                                        return "label-default";
                                    })();
                                    return bind($$Error.wrapJsonError(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("labelClass"))(defaultLabelClass)))(function (labelClass) {
                                        return bind($$Error.wrapJsonError(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("class"))("")))(function (cls) {
                                            return bind(decodeFormFields(v3))(function (fields) {
                                                var subform = {
                                                    id: v,
                                                    label: label,
                                                    labelClass: labelClass,
                                                    section: section,
                                                    collapsible: collapsible,
                                                    expanded: expanded,
                                                    cls: cls,
                                                    fields: fields
                                                };
                                                if (v2 === "SubForm") {
                                                    return pure(wrapFormWidget1(subform));
                                                };
                                                if (v2 === "StudentSubForm") {
                                                    return pure(wrapFormWidget2(new Widgets_Form_StudentSubForm.StudentSubForm(subform)));
                                                };
                                                if (v2 === "EmployerSubForm") {
                                                    return pure(wrapFormWidget3(Widgets_Form_AutoFillSubForm.employerSubForm(subform)));
                                                };
                                                if (v2 === "CourseSubForm") {
                                                    return pure(wrapFormWidget3(Widgets_Form_AutoFillSubForm.courseSubForm(subform)));
                                                };
                                                return $$Error.wrapJsonError(new Data_Either.Left(new Data_Argonaut_Decode_Error.AtKey("type", new Data_Argonaut_Decode_Error.UnexpectedValue(encodeJson(v2)))));
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            };
            if (Data_String_CodeUnits.contains("AutoFillSelect")(v2)) {
                return $$Error.wrapJsonError(bind(getField1(v1)("value"))(function (value) {
                    return bind(getField4(value)("label"))(function (label) {
                        return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(value)("class"))(""))(function (cls) {
                            return bind(getField5(value)("options"))(function (options) {
                                return bind(getFieldOptional$prime(value)("placeholder"))(function (placeholder) {
                                    return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime2(value)("default"))(Data_Argonaut_Core.fromString("")))(function ($$default) {
                                        return new Data_Either.Right(wrapFormWidget4(Widgets_Form_Select.initSelectWidget({
                                            id: v,
                                            label: label,
                                            cls: cls,
                                            options: options,
                                            placeholder: placeholder,
                                            value: new Data_Maybe.Just($$default)
                                        })));
                                    });
                                });
                            });
                        });
                    });
                }));
            };
            if (Data_String_CodeUnits.contains("Expectations")(v2)) {
                return bind($$Error.wrapJsonError(getField1(v1)("value")))(function (v3) {
                    return bind($$Error.wrapJsonError(getField(v3)("label")))(function (label) {
                        return bind($$Error.wrapJsonError(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("class"))("")))(function (cls) {
                            return bind(decodeFormFields(v3))(function (fields) {
                                var subform = {
                                    id: v + "-entry",
                                    label: Data_Maybe.Nothing.value,
                                    labelClass: "",
                                    section: false,
                                    collapsible: false,
                                    expanded: true,
                                    cls: cls,
                                    fields: fields
                                };
                                return bind($$Error.wrapJsonError((function () {
                                    if (v2 === "Expectations") {
                                        return new Data_Either.Right(Widgets_Form_Expectations.courseExpectationsWidget);
                                    };
                                    if (v2 === "CourseExpectations") {
                                        return new Data_Either.Right(Widgets_Form_Expectations.courseExpectationsWidget);
                                    };
                                    if (v2 === "EmployerExpectations") {
                                        return new Data_Either.Right(Widgets_Form_Expectations.employerExpectationsWidget);
                                    };
                                    return new Data_Either.Left(new Data_Argonaut_Decode_Error.AtKey("type", new Data_Argonaut_Decode_Error.UnexpectedValue(encodeJson(v2))));
                                })()))(function (expectationsWidget) {
                                    return new Data_Either.Right(expectationsWidget(subform)({
                                        id: v,
                                        label: label,
                                        cls: cls
                                    }));
                                });
                            });
                        });
                    });
                });
            };
            if (v2 === "EmployerSelect") {
                return $$Error.wrapJsonError(bind(getField1(v1)("value"))(function (v3) {
                    return bind(getField(v3)("label"))(function (label) {
                        return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("class"))(""))(function (cls) {
                            return bind(Data_Argonaut_Decode_Combinators.defaultField(Data_Argonaut_Decode_Decoders["getFieldOptional$prime"](decodePhpJObj)(v1)("options"))(Foreign_Object.empty))(function (options) {
                                return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime1(options)("contact"))(false))(function (contact) {
                                    return new Data_Either.Right(wrapFormWidget5(Widgets_Form_EmployerSelect.initEmployerSelect({
                                        id: v,
                                        label: label,
                                        cls: cls,
                                        contact: contact
                                    })));
                                });
                            });
                        });
                    });
                }));
            };
            if (v2 === "Date") {
                return $$Error.wrapJsonError(bind(getField1(v1)("value"))(function (v3) {
                    return bind(getField(v3)("label"))(function (label) {
                        return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("class"))(""))(function (cls) {
                            return bind(getFieldOptional$prime(v3)("default"))(function (value) {
                                return new Data_Either.Right(wrapFormWidget6({
                                    id: v,
                                    label: label,
                                    cls: cls,
                                    value: bindFlipped(Widgets_Form_Date.parseDate)(value)
                                }));
                            });
                        });
                    });
                }));
            };
            if (v2 === "Telephone") {
                return $$Error.wrapJsonError(bind(getField1(v1)("value"))(function (v3) {
                    return bind(getField(v3)("label"))(function (label) {
                        return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("class"))(""))(function (cls) {
                            return bind(getFieldOptional$prime(v3)("placeholder"))(function (placeholder) {
                                return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("default"))(""))(function (value) {
                                    return new Data_Either.Right(wrapFormWidget7({
                                        id: v,
                                        label: label,
                                        cls: cls,
                                        placeholder: placeholder,
                                        value: value
                                    }));
                                });
                            });
                        });
                    });
                }));
            };
            if (v2 === "Radio") {
                return $$Error.wrapJsonError(bind(getField1(v1)("value"))(function (v3) {
                    return bind(getField(v3)("label"))(function (label) {
                        return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("class"))(""))(function (cls) {
                            return bind(getField6(v3)("options"))(function (options) {
                                return bind(getFieldOptional$prime(v3)("default"))(function (value) {
                                    return new Data_Either.Right(wrapFormWidget8({
                                        id: v,
                                        label: label,
                                        cls: cls,
                                        options: options,
                                        value: value
                                    }));
                                });
                            });
                        });
                    });
                }));
            };
            if (v2 === "Checkbox") {
                return $$Error.wrapJsonError(bind(getField1(v1)("value"))(function (v3) {
                    return bind(getField(v3)("label"))(function (label) {
                        return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("class"))(""))(function (cls) {
                            return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime1(v3)("default"))(false))(function (value) {
                                return new Data_Either.Right(wrapFormWidget9({
                                    id: v,
                                    label: label,
                                    cls: cls,
                                    legacy: Foreign_Object.member("options")(v3),
                                    value: value
                                }));
                            });
                        });
                    });
                }));
            };
            if (v2 === "Number") {
                return $$Error.wrapJsonError(bind(getField1(v1)("value"))(function (v3) {
                    return bind(getField(v3)("label"))(function (label) {
                        return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("class"))(""))(function (cls) {
                            return bind(getFieldOptional$prime(v3)("placeholder"))(function (placeholder) {
                                return bind(getField7(v3)("step"))(function (step) {
                                    return bind(getFieldOptional$prime3(v3)("default"))(function (value) {
                                        return new Data_Either.Right(wrapFormWidget10({
                                            id: v,
                                            label: label,
                                            cls: cls,
                                            step: step,
                                            placeholder: placeholder,
                                            value: value
                                        }));
                                    });
                                });
                            });
                        });
                    });
                }));
            };
            if (v2 === "Label") {
                return $$Error.wrapJsonError(bind(getField1(v1)("value"))(function (v3) {
                    return bind(getField(v3)("label"))(function (label) {
                        return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("class"))(""))(function (cls) {
                            return new Data_Either.Right(wrapFormWidget11({
                                id: v,
                                label: label,
                                cls: cls
                            }));
                        });
                    });
                }));
            };
            if (v2 === "Text") {
                return $$Error.wrapJsonError(bind(getField1(v1)("value"))(function (v3) {
                    return bind(getField(v3)("label"))(function (label) {
                        return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("class"))(""))(function (cls) {
                            return bind(getFieldOptional$prime(v3)("placeholder"))(function (placeholder) {
                                return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("default"))(""))(function (value) {
                                    return new Data_Either.Right(wrapFormWidget12({
                                        id: v,
                                        label: label,
                                        cls: cls,
                                        placeholder: placeholder,
                                        value: value
                                    }));
                                });
                            });
                        });
                    });
                }));
            };
            if (v2 === "Select") {
                return $$Error.wrapJsonError(bind(getField1(v1)("value"))(function (value) {
                    return bind(getField4(value)("label"))(function (label) {
                        return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(value)("class"))(""))(function (cls) {
                            return bind(getField5(value)("options"))(function (options) {
                                return bind(getFieldOptional$prime(value)("placeholder"))(function (placeholder) {
                                    return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime2(value)("default"))(Data_Argonaut_Core.fromString("")))(function ($$default) {
                                        return new Data_Either.Right(wrapFormWidget4(Widgets_Form_Select.initSelectWidget({
                                            id: v,
                                            label: label,
                                            cls: cls,
                                            options: options,
                                            placeholder: placeholder,
                                            value: new Data_Maybe.Just($$default)
                                        })));
                                    });
                                });
                            });
                        });
                    });
                }));
            };
            if (v2 === "TextArea") {
                return $$Error.wrapJsonError(bind(getField1(v1)("value"))(function (v3) {
                    return bind(getField(v3)("label"))(function (label) {
                        return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("class"))(""))(function (cls) {
                            return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime4(v3)("placeholder"))(Data_Maybe.Nothing.value))(function (placeholder) {
                                return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("default"))(""))(function (value) {
                                    return new Data_Either.Right(wrapFormWidget13({
                                        id: v,
                                        label: label,
                                        cls: cls,
                                        placeholder: placeholder,
                                        value: value
                                    }));
                                });
                            });
                        });
                    });
                }));
            };
            if (v2 === "DateTime") {
                return $$Error.wrapJsonError(bind(getField1(v1)("value"))(function (v3) {
                    return bind(getField(v3)("label"))(function (label) {
                        return bind(Data_Argonaut_Decode_Combinators.defaultField(getFieldOptional$prime(v3)("class"))(""))(function (cls) {
                            return bind(getFieldOptional$prime(v3)("default"))(function (value) {
                                return new Data_Either.Right(wrapFormWidget14({
                                    id: v,
                                    label: label,
                                    cls: cls,
                                    value: bindFlipped(Internal_Luxon.fromISO)(value)
                                }));
                            });
                        });
                    });
                }));
            };
            return new Data_Either.Left(new $$Error.DecodeError(new Data_Argonaut_Decode_Error.AtKey("type", new Data_Argonaut_Decode_Error.UnexpectedValue(encodeJson(v2)))));
        };
    };
};
var decodeFormFields = function (obj) {
    var handleParseErrors = function (v) {
        return function (v1) {
            return function (v2) {
                if (v2 instanceof Data_Either.Right) {
                    return new Data_Either.Right(v2.value0);
                };
                if (v2 instanceof Data_Either.Left && $$Error.sentryFlag) {
                    return $$Error.tagContext(new $$Error.LoadingJson("form widget " + v, v1))(new Data_Either.Left(v2.value0));
                };
                if (v2 instanceof Data_Either.Left) {
                    return pure(wrapFormWidget15({
                        id: v,
                        err: v2.value0
                    }));
                };
                throw new Error("Failed pattern match at API.FormType (line 252, column 5 - line 256, column 45): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
            };
        };
    };
    return bind($$Error.wrapJsonError(Data_Argonaut_Decode_Decoders.getField(decodePhpJObj)(obj)("fields")))(function (fields) {
        return traverse(function (v) {
            return handleParseErrors(v.value0)(v.value1)(toFormWidgetState(v));
        })(Data_Array.filter(function (v) {
            return notHiddenWidget(v.value1);
        })(Foreign_Object.toArrayWithKey(Data_Tuple.Tuple.create)(fields)));
    });
};
var attemptDecodeFormType = function (json) {
    return bind($$Error["wrapJsonError$prime"](json)(Data_Argonaut_Decode_Decoders.decodeJObject(json)))(function (obj) {
        return bind(decodeFormFields(obj))(function (fields) {
            return $$Error["wrapJsonError$prime"](json)(bind(getField8(obj)("id"))(function (id) {
                return bind(getField(obj)("type"))(function (type$prime) {
                    return bind(getField(obj)("abbr"))(function (abbr) {
                        return bind(getField(obj)("bgColor"))(function (bgColor) {
                            return bind(getField(obj)("label"))(function (label) {
                                return bind(getField9(obj)("priority"))(function (priority) {
                                    return bind(getField10(obj)("mutations"))(function (mutations) {
                                        return bind(getField11(obj)("signatures"))(function (signatures) {
                                            return bind(decodeSections(Data_Maybe.Nothing.value)(obj))(function (sections$prime) {
                                                var workQueueLabel = (function () {
                                                    var $463 = length(signatures) > 0;
                                                    if ($463) {
                                                        return Translate.lookupTranslation("preview-and-sign");
                                                    };
                                                    return Translate.lookupTranslation("preview");
                                                })();
                                                var sections = Data_Array.snoc(sections$prime)(Data_Tree.mkTree({
                                                    id: "signature-anchor",
                                                    workQueueLabel: workQueueLabel
                                                })(empty));
                                                return pure({
                                                    id: id,
                                                    type: type$prime,
                                                    abbr: abbr,
                                                    bgColor: bgColor,
                                                    label: label,
                                                    priority: priority,
                                                    mutations: mutations,
                                                    fields: fields,
                                                    signatures: signatures,
                                                    sections: sections
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            }));
        });
    });
};
var extractFormType = function (json) {
    return bind($$Error["wrapJsonError$prime"](json)(bind(bind(Data_Argonaut_Decode_Decoders.decodeJObject(json))(function (v) {
        return getField1(v)("data");
    }))(function (v) {
        return getField3(v)("form_type");
    })))(function (obj) {
        return attemptDecodeFormType(obj);
    });
};
var formQueryRequest = function (id) {
    return gqlQuery("\x0aquery FormType" + (queryStringParams([ "$id: ID!" ]) + (" {\x0a    form_type" + (queryStringParams([ "id: $id" ]) + (" {\x0a        " + (formTypeFields(true) + "\x0a    }\x0a}"))))))({
        id: id
    })(extractFormType);
};
var formQuery = /* #__PURE__ */ (function () {
    var $464 = GraphQL_Join.runGraphQL(GraphQL_Join.stringGQL);
    return function ($465) {
        return $464(formQueryRequest($465));
    };
})();
var areFormsSelected = function (dictFunctor) {
    var map1 = Data_Functor.map(dictFunctor);
    return function (dictFoldable) {
        var $466 = areAllSelected(dictFoldable);
        var $467 = map1(function (v) {
            return v.id;
        });
        return function ($468) {
            return $466($467($468));
        };
    };
};
export {
    emptyFormPickerMap,
    isFormSelected,
    getSelectedForm,
    selectForm,
    deselectForm,
    selectForms,
    areFormsSelected,
    setFormOrder,
    formListQuery,
    formsQuery,
    formQueryRequest,
    formQuery,
    extractFormType,
    formTypeFields,
    attemptDecodeFormType,
    decodeSections,
    decodeSection,
    hiddenWidgets,
    notHiddenWidget,
    decodePhpJObj,
    decodeFormFields,
    toFormWidgetState,
    matchWidget
};
//# sourceMappingURL=index.js.map
